import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from '../../../../hooks/useTranslation';

type OutageHistoryItemProps = {
  outageDate: string;
  isPartialOutage: boolean;
  cause: string;
  duration: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    textMatterStrong: {
      fontSize: 18,
      fontWeight: 600,
    },
    textMatterLight: {
      fontSize: 16,
    },
    container: {
      display: 'flex',
    },

    flexBetween: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
    },
  }),
);

export function OutageHistoryItem(props: OutageHistoryItemProps) {
  const { t } = useTranslation();
  const { cause, duration, isPartialOutage, outageDate } = props;
  const classes = useStyles();

  //TODO: Update implementation after the api ready

  return (
    <Box className={classes.flexBetween}>
      <Box>
        <Typography variant="h6" className={classes.textMatterStrong}>
          {outageDate}
        </Typography>
        <Typography variant="h6" className={classes.textMatterLight}>
          {cause}
        </Typography>
      </Box>
      <Box>
        <Typography variant="h6" className={classes.textMatterStrong}>
          {isPartialOutage
            ? t('PARTIAL_OUTAGE_LABEL')
            : // TODO: Update this label after full details are available
              t('PARTIAL_OUTAGE_LABEL')}
        </Typography>
        <Typography variant="h6" className={classes.textMatterLight}>
          {duration}
        </Typography>
      </Box>
    </Box>
  );
}
